import React from "react";
import { Button, Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import { Link } from "gatsby";
import PropTypes from "prop-types";

import Logo from "./Logo";
import SocialProfiles from "./SocialProfiles";

import { useNavItems } from "../hooks/useNavItems";
import { getNavItemProps } from "../utils/utils";

import "../styles/components/Footer.scss";

const Footer = ({ layout }) => {
    const navItems = useNavItems({ showOnFooter: true });

    return (
        <Navbar as="footer" className="footer py-5 mt-auto">
            <Container className="p-0">
                <Nav className="w-100 m-0" as={Row}>
                    <Col className="mb-4" md={3}>
                        <Logo />
                        <Button
                            size="lg"
                            className="d-block mt-2"
                            as="a"
                            href="tel:8009743458"
                        >
                            800-974-3458
                        </Button>
                    </Col>

                    {layout !== "simplified" &&
                        navItems.map(navItem => {
                            if (!navItem?.childrenItems?.length) return null;

                            return (
                                <Col
                                    key={navItem.id}
                                    xs={6}
                                    md={3}
                                    className="mb-4"
                                >
                                    <Nav.Item as="h5">{navItem.title}</Nav.Item>
                                    {navItem.childrenItems.map(child => (
                                        <Nav.Link
                                            key={child.id}
                                            {...getNavItemProps(child)}
                                        >
                                            {child.title}
                                        </Nav.Link>
                                    ))}
                                </Col>
                            );
                        })}

                    <Col xs={6} md={3} className="mb-4 ms-md-auto">
                        <Nav.Item as="h5">Connect With Us</Nav.Item>
                        <SocialProfiles />
                    </Col>

                    <Col xs={12}>
                        <Row>
                            <Col
                                className="disclaimer-text text-center text-md-start"
                                md={6}
                            >
                                <Link className="text-black" to="/privacy">
                                    Terms of Use and Privacy Policy
                                </Link>{" "}
                                |{" "}
                                <Link
                                    className="text-black"
                                    to="/cookie-policy"
                                >
                                    Cookie Policy
                                </Link>
                            </Col>
                            <Col
                                className="disclaimer-text text-center text-md-end"
                                md={6}
                            >
                                © 2016 - Present. HomeCare.com. All rights
                                reserved.
                            </Col>
                        </Row>
                    </Col>
                </Nav>
            </Container>
        </Navbar>
    );
};

Footer.propTypes = {
    layout: PropTypes.string,
};

export default Footer;
